import compareAsc from 'date-fns/compare_asc';

import {createReducer} from 'utils/reducer';
import {Questionnaire} from '../actions';

const initialState = {
    ids: null,
};

export default createReducer(initialState, {
    [Questionnaire.update]: (state, questionnaires) => {
        const data = {};

        questionnaires.forEach(questionnaire => {
            data[questionnaire.id] = questionnaire;
        })

        return {
            ...data,
            ids: questionnaires.sort((q1, q2) => {
                const now = new Date();
                return compareAsc(q1.start || now, q2.start || now);
            }).map(({id}) => id),
        };
    },
});



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/questionnaire.js